import { selectRequestByType } from 'ducks/requests/selectors'
import { createBasicSelector } from 'util/redux'
import { emptyObj } from 'util/objects'

import {
  FETCH_CUSTOMER_RATING_SETTINGS,
  UPSERT_CUSTOMER_RATING_SETTINGS,
} from '../types'
import { selectCustomerRatingSettingsById } from './selectCustomerRatingSettingsById'

export const selectCustomerRatingSettingById = createBasicSelector(
  selectCustomerRatingSettingsById,
  (state, byId) => byId,
  (byId, settingId) => byId[settingId] || emptyObj
)

export const selectIsLoadingCustomerRatingSettings = state =>
  selectRequestByType(state, FETCH_CUSTOMER_RATING_SETTINGS).loading

export const selectIsLoadingCustomerRatingSetting = state =>
  selectRequestByType(state, UPSERT_CUSTOMER_RATING_SETTINGS).loading
